module.exports = __webpack_public_path__ + "static/media/dna.acc9b8f3.svg";